<div class="title">
    Create New Flag
</div>

<form (submit)="submit($event)">
    <mat-form-field>
        <input matInput
               [formField]="flagForm.name"
               placeholder="Flag Name">
        <mat-error>
            <app-field-errors [formField]="flagForm.name"></app-field-errors>
        </mat-error>
    </mat-form-field>

    <mat-checkbox [formField]="flagForm.preventsDelete"
                  matTooltip="Whether a domain using this flag will be prevented from being deleted">Prevents Delete</mat-checkbox>

    <div class="actions">
        <button mat-raised-button
                color="primary"
                [disabled]="!canSubmit()"
                type="submit">Submit</button>
        <button mat-raised-button
                type="button"
                mat-dialog-close="">Cancel</button>
    </div>
</form>
